























import { Component, Prop, Watch, Mixins } from "vue-property-decorator";
import { Getter } from "vuex-class";
import {
  parsePhoneNumberFromString,
  AsYouType,
  CountryCode,
} from "libphonenumber-js";
import { isEmail } from "@/utils/regex";

// Mixins
import {
  WidgetMixin,
  IdMixin,
  FieldMixin,
  GroupMixin,
  InputMixin,
  Validator,
} from "./mixins";
import AutoMixin from "@/mixins/auto";

@Component
export default class WLookup extends Mixins(
  Mixins(WidgetMixin, IdMixin, FieldMixin, GroupMixin, AutoMixin),
  InputMixin
) {
  localValue: string = "";

  @Prop({ type: String })
  defaultCountryCode?: CountryCode;

  created() {
    this.labelId = this.uniqueId("__W_LOOKUP_");
  }

  get phone() {
    return parsePhoneNumberFromString(
      this.localValue || "",
      this.defaultCountryCode
    );
  }

  get isPhone() {
    return this.phone && this.phone.isValid();
  }

  get isEmail() {
    return isEmail(this.localValue);
  }

  get icon() {
    return this.isPhone ? "phone" : this.isEmail ? "envelope" : "address-book";
  }

  inputHandler(value: string) {
    this.localValue =
      new AsYouType(this.defaultCountryCode).input(value) || value;
  }

  changeHandler(value: string) {
    this.fieldValue = this.isPhone
      ? this.phone && this.phone.number.toString()
      : value;
  }

  @Validator("required")
  requiredValidator(value: any) {
    return !!value;
  }

  @Validator("lookup", true)
  lookupValidator(value: any) {
    if (value) {
      const number = parsePhoneNumberFromString(value);
      return (number && number.isValid()) || isEmail(value);
    }
    return true;
  }
}
